import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { Page404Component } from "./authentication/page404/page404.component";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
import { RoleMappings } from "./_enums/RoleMappings";
import { AuthGuard } from './_helpers/auth.guard';
import { LandingLayoutComponent } from './layout/app-layout/landing-layout/landing-layout.component';
import {GuestLayoutComponent} from "./layout/app-layout/guest-layout/guest-layout.component";
import {CustomGuard} from "./_helpers/custom.guard";
import {GuestGuard} from "./_helpers/guest.guard";

const routes: Routes = [
  {
    path: "portal",
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "/authentication/signin", pathMatch: "full" },
      {
        path: "admin",
        canActivate: [AuthGuard],
        data: {
          role: [RoleMappings.Admin],
        },
        loadChildren: () =>
          import("./admin/admin.module").then((m) => m.AdminModule),
      },
      {
        path: "reports",
        canActivate: [AuthGuard],
        data: {
          role: [RoleMappings.Admin],
        },
        loadChildren: () =>
          import("./reports/reports.module").then((m) => m.ReportsModule),
      },
      {
        path: "contributor",
        canActivate: [AuthGuard],
        data: {
          role: [RoleMappings.Admin, RoleMappings.Contributor],
        },
        loadChildren: () =>
          import("./contributor/contributor.module").then((m) => m.ContributorModule),
      },
      {
        path: "dashboard",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
      {
        path: "profile",
        canActivate: [AuthGuard],
        loadChildren: () =>
          import("./profile/profile.module").then((m) => m.ProfileModule),
      },
      {
        path: "medical-record",
        canActivate: [AuthGuard],
        data: {
          role: [RoleMappings.Patient],
        },
        loadChildren: () =>
          import("./medical-record/medical-record.module").then(
            (m) => m.MedicalRecordModule
          ),
      },
      {
        path: 'patient-medical-record',
        canActivate: [AuthGuard],
        data: {
          role: [RoleMappings.Doctor],
        },
        loadChildren: () =>
          import('./patient-medical-record/medical-record.module').then(m => m.PatientMedicalRecordModule)
      },
      {
        path: "appointments",
        canActivate: [AuthGuard],
        data: {
          role: [RoleMappings.Doctor, RoleMappings.Patient],
        },
        loadChildren: () =>
          import("./appointments/appointments.module").then(
            (m) => m.AppointmentsModule
          ),
      },
    ],
  },
  {
    path: "authentication",
    component: AuthLayoutComponent,
    canActivate: [CustomGuard],
    loadChildren: () =>
      import("./authentication/authentication.module").then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: "guest",
    component: GuestLayoutComponent,
    canActivate: [GuestGuard],
    loadChildren: () =>
      import("./guest/guest.module").then(
        (m) => m.GuestModule
      ),
  },
  {
    path: "",
    component: LandingLayoutComponent,
    loadChildren: () =>
      import("./landing/landing.module").then(
        (m) => m.LandingModule
      ),
  },
  { path: "**", component: Page404Component },
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
